export default __webpack_public_path__ + "static/media/bride.d3c645de.webp";